var _rect, _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 1920 858",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "current",
    height: "current",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1762.24 765.888L1795.39 765.349C1804.45 765.202 1812.98 761.025 1818.65 753.954L1831.45 737.991C1838.02 729.798 1834.71 717.581 1824.91 713.818L1823.95 713.45C1816.33 710.524 1807.79 714.465 1805.08 722.165V722.165C1802.55 729.323 1805.97 737.217 1812.92 740.271L1830.99 748.211C1843.32 753.632 1857.65 751.664 1868.07 743.12L1910.87 708.012",
    stroke: "#F2F2F2",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 137.5,
    r: 30.5,
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 119.5,
    r: 31.5,
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.5f82f64149024f6ee560a750af07b5bd.svg";
export { ForwardRef as ReactComponent };